import type { FileName } from "@pdfking/structs"

/** What every key inside a folder starts with.
 *
 * The root is "", any other folder is its path with a single trailing slash —
 * so a store whose keys are ordered (an index range, a sorted scan) can narrow
 * to the folder before anything walks it. Leading and repeated slashes are the
 * same folder written differently, and normalize to one form here. */
export const FolderPrefix = (path: FileName): FileName => {
  const trimmed = path.replace(/^\/+/, "").replace(/\/+$/, "")
  return (trimmed ? `${trimmed}/` : "") as FileName
}
